module.exports = __webpack_public_path__ + "img/sub_webmaster.e79e33f5.svg";